import {useSelector} from 'react-redux';

export default () =>
	useSelector(({reconciliations}) => {
		return [reconciliations.data, reconciliations.lastRefreshed];
	});
